import { toBooleanFromBit } from './productSubCategoryHelpers';

export const mapProductSubCategoryFromApi = (row) => {
  if (!row) return null;
  return {
    SubCategoryId: row.SubCategoryId ?? null,
    CategoryId: row.CategoryId ?? null,
    CategoryName: row.CategoryName || '',
    SubCategoryName: row.SubCategoryName || '',
    Slug: row.Slug || '',
    ImageUrl: row.ImageUrl || '',
    DisplayOrder: row.DisplayOrder ?? 0,
    IsActive: toBooleanFromBit(row.IsActive, true),
  };
};

export const buildProductSubCategorySavePayload = (data, userId) => ({
  SubCategoryId: data.SubCategoryId || null,
  CategoryId: data.CategoryId || null,
  SubCategoryName: data.SubCategoryName?.trim() || '',
  Slug: data.Slug?.trim() || '',
  ImageUrl: data.ImageUrl?.trim() || null,
  DisplayOrder: data.DisplayOrder ?? 0,
  IsActive: data.IsActive !== false && data.IsActive !== 0 ? 1 : 0,
  UserId: userId,
});
